export const Env = {
  PRODUCTION: 'production',
  TEST: 'test',
  DEVELOPMENT: 'development',
} as const;
export type Env = (typeof Env)[keyof typeof Env];

const transformEnv = (env: string): Env => {
  if (['production', 'prod'].includes(env.toLowerCase())) {
    return Env.PRODUCTION;
  }

  if (['test', 'testing'].includes(env.toLowerCase())) {
    return Env.TEST;
  }

  return Env.DEVELOPMENT;
};

export const getEnv = (): Env => {
  // @ts-ignore TODO: fix this type
  const envVar = import.meta.env.VITE_API_URL ?? process.env.NODE_ENV;
  if (envVar) {
    return transformEnv(envVar);
  }

  return Env.PRODUCTION;
};
